'use strict';

import {keys} from 'ts-transformer-keys';
import _ from 'lodash';

import Reference, {ReferenceOnlyJsonAttributes} from '~/shared/src/ci/Reference';
import {renderValue} from '~/shared/src/utilities/valueRenderers';
import {FilterValueType} from '~/shared/src/validationSchemes/modules/overview';

import dbDefinitionMapper from '~/backend/src/connectors/db/dbDefinitionMapper';


const allowedAttributes = ( keys<ReferenceOnlyJsonAttributes>() as string[] ).concat( 'attributesModified' );

class ReferenceTemplateStringResolver {
    rawMode : boolean = false;

    protected _reference? : Reference;

    constructor( reference : Reference | undefined ) {
        this._reference = reference;

        return new Proxy( this, this );
    }

    set( target : ReferenceTemplateStringResolver, attribute : string, value : any ) {
        let retVal = false;

        if ( attribute === 'rawMode' ) {
            retVal = true;
            this.rawMode = value;
        }

        return retVal;
    }

    get( target : ReferenceTemplateStringResolver, attribute : Symbol ) : ( () => string );
    get( target : ReferenceTemplateStringResolver, attribute : string ) : string;
    get( target : ReferenceTemplateStringResolver, attribute : string | Symbol ) : string | ( () => string ) {
        let retVal : string | ( () => string ) = '';

        if ( typeof attribute === 'symbol' ) {
            if ( attribute === Symbol.toPrimitive ) {
                retVal = () => {
                    return 'reference';
                };
            }
        }
        else if ( this._reference ) {
            retVal = attribute as string;

            attribute = _.lowerFirst( attribute as string );

            if ( allowedAttributes.includes( attribute ) ) {
                const rawValue = this._reference[ attribute as keyof ReferenceOnlyJsonAttributes ];

                if ( rawValue !== undefined && rawValue !== null && rawValue !== '' ) {
                    retVal = renderValue( dbDefinitionMapper.schemas[ this._reference.schema ].views[ 'reference' ].getFieldType( attribute ) as FilterValueType, rawValue, undefined, this.rawMode ) as string;
                }
                else {
                    retVal = '';
                }
            }
            else if ( attribute === 'setId' ) {
                retVal = String( this._reference.referenceSetId );
            }
            else if (
                attribute === 'referenceSetName' || attribute === 'setName'
                || attribute === 'referenceTypeName' || attribute === 'typeName'
            ) {
                retVal = !this.rawMode ? this._reference.referenceSet.referenceTypeLabel : this._reference.referenceSet.referenceTypeName;
            }
            else if ( attribute === 'cardinality' ) {
                retVal = this._reference.referenceSet.cardinality;
            }
            else if ( attribute === 'typeId' ) {
                retVal = String( this._reference.referenceSet.referenceTypeId );
            }
            else if ( attribute === 'statusName' ) {
                retVal = !this.rawMode ? this._reference.status.label : this._reference.status.name;
            }
        }

        if ( !retVal ) {
            retVal = `reference.${String( attribute )}`;
        }

        return retVal;
    }
}

export default ReferenceTemplateStringResolver;
